<template>
<div class="w-full" v-if="!loading">
    <lcontainer class="mb-4">
        <div class="heading flex flex-row items-center justify-between py-2 px-8">
            <div>
                <div class="page text-white">{{growth_plan.title}}</div>
                <p v-if="$route.query.view === 'review'" class="text-white"><i><b>(NOTE: Reloading This Page Will Reset Answers. Click Save When Finished To Save Progress</b></i></p>
                                   <!-- <p class="text-left m-2 text-white">View All  The Growth Plans in {{getLearnerCourse.title}} </p> -->
            </div>
            <div>
                <img :src="require('../../../assets/tenant_image.png')" alt="" />
            </div>

        </div>
    </lcontainer>
    <div class="">
        <lCrumbs :breadcrumb="breadcrumbItems" />
        <p><small><i>NOTE. If your answer doesnt change kindly view your previous answer to help guide your new  answer in the textbox</i></small></p>

        <div class="block sm:flex sm:justify-even sm:flex-wrap">
            <div class="w-full flex flex-wrap" v-for="(question, index) in form.response" :key="index">
                <div class="flex w-full flex-wrap justify-between">
                    <p v-html="question.question" class="py-2 uppercase main-tenant-color"></p>
                
                </div>
                <div class="my-4 w-full md:w-1/2">
                <div class="mb-5 mr-auto">
                        <button v-if="question.has_template === 1 &&  question.template_url !== null"  class="h-8 px-4 text-sm text-indigo-100 transition-colors duration-150 bg-indigo-700 rounded-lg cursor-pointer focus:shadow-outline hover:bg-indigo-800" type="submit"  >
                         <a :href=" question.template_url" download>Download Guide Template</a>
                    </button>
                </div>
                    <main class="mx-2">
                        <p v-if="!question.template_answer">ENTER YOUR ANSWER HERE</p>
                        <p v-if="question.template_answer">UPLOAD YOUR ANSWER HERE (Upload Filled Guide Template that you downloaded above)</p>
                        <ltextarea v-if="question.has_image !== 1" v-model="question.answer" placeholder="Enter Answer" />
                        <div v-if="question.template_answer ">
                            <button v-if="question.template_answer !== null &&  question.template_answer !== '' && typeof question.template_answer !== 'undefined' " 
                            class="h-8 px-4 text-sm text-pink-100 transition-colors duration-150 bg-indigo-700 rounded-lg cursor-pointer focus:shadow-outline hover:bg-indigo-800" type="submit"  >
                           <a :href=" question.template_answer" download>View Your Uploaded Answer Here</a>
                        </button>


                        </div>
                        <div v-if="question.has_image === 1" >
                            <p class="mt-5"> Upload or (Re-Upload) Your Filled Guide Template Here</p>
                            <input @change="handleFileUpload($event,index)" type="file" >



                        </div>

                           <div  v-if="$route.query.view === 'review'">
                                <button @click="generateReview(question.id)" class="h-8 px-4 mt-5 mb-5  text-sm text-indigo-100 transition-colors duration-150 bg-red-700 rounded-lg cursor-pointer focus:shadow-outline hover:bg-indigo-800">Click To View Previous Response</button>
                            <modal  @click="hide(question.id)" :name="'review' + question.id">
                                  <main class="mx-5 my-5">
                                       <ltextarea v-if="previous_response !== null && previous_response.has_image !== 1" v-model="previous_response.answer" placeholder="Enter Answer" />
                              <div v-if="previous_response !== null && previous_response.template_answer ">
                                        <button v-if="previous_response.template_answer !== null &&  previous_response.template_answer !== '' && typeof previous_response.template_answer !== 'undefined' " 
                            class="h-8 px-4 text-sm text-pink-100 transition-colors duration-150 bg-indigo-700 rounded-lg cursor-pointer focus:shadow-outline hover:bg-indigo-800" type="submit"  >
                           <a :href=" previous_response.template_answer" download>You Can View Your Uploaded Answer By Clicking  Here</a>
                        </button>
                            </div>
                                </main>
                            </modal>
                           </div>
                    </main>
                </div>
            </div>
            <div class="flex flex-col justify-center items-center">
                <div class="mb-2">
                    <lms-button v-if="!hasSubmitted" @click="handleFormSubmit">{{button.text}}</lms-button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations
} from "vuex";
import Input from "../../../components/general/input";
import axios from "axios";
import { store } from "@/store/store";
export default {
    name: "single",
    data() {
        return {
            growth_plan: "",
            loading: true,
            form: {},
            previousResponse:null,
            errors: [],
            button: {
                text: 'Save'
            },
            hasSubmitted:0,
            previous_response:null
        }
    },
    components: {
        Input,
        lcontainer: () => import("@/components/general/container"),
        GrowthCard: () => import("@/components/learner/growthCard"),
        LmsButton: () => import("@/components/general/button"),
        lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
        linput: () => import("@/components/general/input"),
        ltextarea: () => import("@/components/general/textarea"),
        lselect: () => import("@/components/forms/select"),
        PageHeader: () => import("@/components/general/pageheader"),
        linput: () => import("@/components/general/input"),
    },
    methods: {
        ...mapMutations(["updateLoader"]),
        ...mapActions(["verifyCompletedCourses","LearnerShowGrowthPlanResponse", "tenantFetchGrowthPlan", "submitLearnerCourseGrowthPlan", "fetchSingleLearnerCourse"]),
        async handleFormSubmit() {
            this.button.text = 'Saving....'
            this.errors = [];
            this.updateLoader(true);
            this.form.course_id = this.$route.params.course_id;
            this.form.growth_plan_id = this.$route.params.id
            let res = await this.submitLearnerCourseGrowthPlan(this.form);
            this.updateLoader(false);
            if (res == true || res.status == 200 || res.status == 201) {
                this.button.text = 'Save'

                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "GrowthPlan Saved successfully",
                });
                this.$router.replace({
                    name: "learner-growthplan-home",

                });
            } else {
                this.button.text = 'Save'
                this.errors = res.data.errors[0].source;
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title + 'No Gradables Attached' : "An error occured",
                });
            }
        },
         handleFileUpload(event,id){
              this.updateLoader(true)
            const formData = new FormData();
            formData.append("asset_file", event.target.files[0]);
            formData.append("sign", true);
            formData.append("growthplan", true);
             axios
              .post(`${process.env.VUE_APP_API}/tenant/asset/upload-to-bucket`,formData,{
                  headers: {
                      "content-type": "multipart/form-data",
                      Authorization: `Bearer ${store.state.auth.token}`,
                  },
              })
              .then(res => {
                    this.updateLoader(false)
                      this. form.response[id].template_answer =  res.data.data.file_url
                      this. form.response[id].answer =  res.data.data.file_url
              })
              .catch(err => {
                  console.log(err)
                    this.updateLoader(false)
              })

        },
        generateReview(questionId){
            let found  = this.previousResponse.find(response => response.id === questionId)
            if(typeof found === 'undefined'){
                    this.$Bus.$emit("notify", {
                    type: "error",
                    message: 'No Previous Responses Found'
                });
            }
            else{
                  this.previous_response = found
            this.$modal.show("review" + questionId);
            }
          
        },
        hide(questionId) {
            this.previous_response = null
            this.$modal.hide("review" + questionId);
        },
    },
    async mounted() {
        this.updateLoader(true)
        let res = await this.LearnerShowGrowthPlanResponse({
            course_id: this.$route.params.course_id,
            id: this.$route.params.id,
        });

        if (res.status === 200 || res.status === 201) {
            //console.log(res);
            if (typeof res.growth_plan_response.response !== 'undefined') {
                this.growth_plan = await this.tenantFetchGrowthPlan({
                    id: res.growth_plan_response.growth_plan_id
                });
                this.updateLoader(false)

            } else {
                this.growth_plan = await this.tenantFetchGrowthPlan({
                    id: res.growth_plan_response.id
                });
                this.updateLoader(false)

            }

            if(this.$route.query.view !== 'review'){
            if (typeof res.growth_plan_response.response !== 'undefined') {
                this.hasSubmitted =  res.growth_plan_response.completed
                try{
                    //console.log(res.growth_plan_response.response.length)
                    //console.log(JSON.stringify(res.growth_plan_response.response))
                    this.form.response = JSON.parse(res.growth_plan_response.response)
                }catch(err) {
                    this.form.response = res.growth_plan_response.response
                    console.log(err.response)
                }
                this.updateLoader(false)

            } else {
                   this.hasSubmitted =  res.growth_plan_response.completed
                this.form.response = res.growth_plan_response.questions
                this.updateLoader(false)

            }
            }
            else{
                // try{
                    this.previousResponse = JSON.parse(res.growth_plan_response.response)
                // }catch(err) {
                //     console.log(err.response)
                // }
                this.form.response = this.growth_plan.questions
                this.updateLoader(false)

            }
          

            // try{

            // }
            // catch (e) {
            // }
            // finally {
            //     this.$router.go(-1);
            //     this.$Bus.$emit('notify',{
            //         type: "error",
            //         message: "An Error Occured While Trying to compile growthplan response",
            //     })

            // }

        } else {
            this.growth_plan = await this.tenantFetchGrowthPlan({
                id: this.$route.params.id

            });
            this.form.response = this.growth_plan.questions
            this.updateLoader(false)
        }
        this.loading = false
        this.updateLoader(false)
    },
    computed: {
        ...mapGetters(["getLearnerCourse"]),
        breadcrumbItems() {
            return [{
                    disabled: true,
                    to: `/learner/growth_plan`,
                    text: "GrowthPlans",
                },
                {
                    disabled: true,
                    to: "#",
                    text: `${this.growth_plan.title}`,
                },
            ]
        }
    }
}
</script>

<style scoped>
</style>
